import { render } from "./ServicesDetails.vue?vue&type=template&id=a2f454fe"
import script from "./ServicesDetails.vue?vue&type=script&lang=js"
export * from "./ServicesDetails.vue?vue&type=script&lang=js"

import "./ServicesDetails.vue?vue&type=style&index=0&id=a2f454fe&lang=css"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__